<template>
    <div :class="classes" ref="dropdown">
        <select ref="dropdownSelect" v-model="dropdownValue">
            <option v-for="option in options" :key="option.value" :value="option.value">{{option.text}}</option>
        </select>
        <div class="dropdown__selected" ref="dropdownSelectedOption" @click="toggleDropdownOpen"></div>
        <input type="text" autocomplete="off" class="dropdown__input" ref="dropdownInput">
        <div class="dropdown__option-wrapper" ref="dropdownOptionsWrapper">
            <div v-for="(option, i) in options" class="dropdown__option" :key="option.value" @click="selectOption(i)">{{option.text}}</div>
        </div>
    </div>
</template>
<script type="text/javascript">
    export default{
        props:{
            "options":{
                type:Array
            },
            "displace":{
                type:Boolean,
                default:false,
            },
            "dark":{
                type:Boolean,
                default:false,
            },
            "value":{
                type:String
            }
        },
        data(){
            return {
                dropdown:null,
                dropdownSelect:null,
                active:false,
                dropdownValue:null
            }
        },
        computed:{
            classes(){
                const classes = ["dropdown"];
                if(this.active){
                    classes.push("dropdown--active");
                }
                if(this.dark){
                    classes.push("dropdown--dark");
                }
                if(this.displace){
                    classes.push("dropdown--displace");
                }
                return classes;   
            }
        },
        methods:{
            closeDropdown(){
                if(!document.activeElement.classList.contains('dropdown__input') 
                    && !document.activeElement.classList.contains('dropdown') && this.dropdown.classList.contains('dropdown--active')){  
                    const options = [...document.getElementsByClassName("dropdown__option")];
                    options.forEach(function(option){
                        option.classList.remove("dropdown__option--hide");
                    });
                    this.dropdownInput.value='';
                    this.active = false;
                }
            },
            toggleDropdownOpen(){
                this.active=!this.active;
                this.dropdownInput.focus();
            },
            selectOption(index){
                const selected = this.options[index];
                this.dropdownSelectedOption.textContent = selected.text
                this.dropdownSelect.selectedIndex = index;
                this.dropdownSelect.dispatchEvent(new Event("change"));
                this.closeDropdown();
            }
        },
        mounted(){
            let that = this;
            that.dropdownValue = that.value
            that.$nextTick(function(){    
                that.dropdown = that.$refs.dropdown;
                that.dropdownSelect = that.$refs.dropdownSelect;
                that.dropdownInput = that.$refs.dropdownInput;
                that.dropdownSelectedOption = that.$refs.dropdownSelectedOption;
                that.dropdownOptionsWrapper = that.$refs.dropdownOptionsWrapper;
                that.dropdownSelect.addEventListener("change",function(){
                    that.$nextTick(function(){
                        that.$emit('input',that.dropdownSelect.value)
                        const currentOption = this.options.filter((option)=>option.value==that.dropdownSelect.value)[0];
                        that.dropdownSelectedOption.textContent = (currentOption!=null) ? currentOption.text : "";
                    })
                })
                that.dropdownInput.addEventListener("keyup",function(){
                    if(that.dropdownInput.value.trim().length>0){
                        const options = [...that.dropdown.getElementsByClassName("dropdown__options")];
                        const newOptions = [];
                        let invalidIndex = Number.MAX_VALUE - options.length;
                        options.forEach(function(option){
                            newOptions[newOptions.length] = {
                                index: (option.textContent.trim().toUpperCase().search(that.dropdownInput.value.trim().toUpperCase())==-1)? 
                                invalidIndex:option.textContent.toUpperCase().search(that.dropdownInput.value.toUpperCase()),
                                opt:option 
                            }
                            invalidIndex++;
                        });
                        newOptions.sort((a, b) => (a.opt.textContent < b.opt.textContent) ? 1 : -1)
                        newOptions.sort((a, b) => (a.index > b.index) ? 1 : -1)
                        newOptions.forEach(function(option){
                            option.opt.parentNode.appendChild(option.opt);
                        })
                    }
                });
                window.addEventListener("click",function(e){
                    if(e.srcElement!=that.dropdown && !that.dropdown.contains(e.srcElement)){
                        that.closeDropdown();
                    }
                })
                if(that.dropdownSelect.selectedIndex != -1){
                    that.dropdownSelectedOption.textContent = that.dropdownSelect.options[that.dropdownSelect.selectedIndex].textContent;
                }
            })
        },
        watch:{
            value:{
                handler(val){
                    this.dropdownValue = val;
                },
                immediate:true,
            },
            dropdownValue(val){
                this.$refs.dropdownSelect.value = val;
                this.$refs.dropdownSelect.dispatchEvent(new Event("change"));
            }
        }

    }
</script>
<style lang="scss" scoped>
    .dropdown,
    .dropdown:focus
    {
        position:relative;
        width: 100%;
        background-color: #FFF;
        color: #333;
        border: solid 1px rgba(0, 0, 0, 0.1);
        outline: none;
        &.dropdown--dark{
            background-color: #333;
            color: #FFF;
            border: solid 1px rgba(255, 255, 255, 0.1);
            .dropdown__option-wrapper{
                background-color: #3b3b3b;
            }
            .dropdown__option{
                border-top: solid 1px rgba(255, 255, 255, 0.1);
                &:hover{
                    background-color: rgba(255, 255, 255, 0.1); 
                }
            }
            .dropdown__selected::after{
                border-top-color: #FFF;
                border-bottom-color: transparent;
            }
            &.dropdown--active .dropdown__selected::after{
                border-bottom-color: #FFF;  
                border-top-color: transparent;
            }
        }
        select{
            display: none;
        }
        .dropdown__input{
            all: unset;
            max-width: 0;
            max-height: 0;
            overflow:hidden;
            opacity: 0;
            border: 0;
            display: none;
            position: absolute;
        }
        &.dropdown--active{
            z-index: 500;
            .dropdown__option{
                display:block;
                position: relative;
                width: 100%;
                &.dropdown__option--hide{
                    display:none;
                }
            }
            .dropdown__selected::after{
                content: "";
                border-top: solid 6px transparent;
                border-left: solid 6px transparent;
                border-right: solid 6px transparent;
                border-bottom: solid 6px #333;
                position:absolute;
                top: 18px;
            }
        }
        .dropdown__option-wrapper{
            background-color: #f5f5f5;
            border:solid 1px rgba(0, 0, 0, 0.1);
            border-top: none;
            position: absolute;
            box-shadow: 3px 5px 5px rgba(0,0,0,0.1);
            left: -1px;
            width: 100%;
        }
        &.dropdown--displace{
            .dropdown__option-wrapper{
                position: relative;
                box-shadow: none;
            }
        }
        .dropdown__selected,
        .dropdown__option{
            padding: 17.5px 1%;
            text-align:center;
            white-space:nowrap;
            cursor: pointer;
            box-sizing: border-box;
        }
        .dropdown__option{
            display:none;
            border-top: solid 1px rgba(0, 0, 0, 0.1);
            height: 100%;
            &:hover{
                background-color: rgba(0, 0, 0, 0.1);   
            }
        }
        .dropdown__selected{
            position: relative;
            background-color: inherit;
            &::after{
                content: "";
                border-top: solid 6px #333;
                border-left: solid 6px transparent;
                border-right: solid 6px transparent;
                border-bottom: solid 6px transparent;
                position:absolute;
                top: 24px;
                width: 0;
                right: min(10%,30px);
            }
            &::before{
                content: "";
                position: absolute;
                top: 0;
                left: 80%;
                bottom: 0;
                right: 0;
                background-color: inherit;
            }
        }
    }
</style>